export const formatDate = (dateStr, locale) => {
    const [year, month, day] = dateStr.split('-').map(Number)
    return new Date(year, month - 1, day).toLocaleDateString(locale, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    })
}
